import Repository from '@/repositories/marketing'
const resource = '/analytics/statistics'
export default {
  fetchStats (config) {
    return Repository.get(`${resource}/campaign.json`, config)
  },
  fetchJourneysStats (config) {
    return Repository.get(`${resource}/workflow.json`, config)
  },
  fetchJourneysDetails (config) {
    return Repository.get(`${resource}/workflow_detailed.json`, config)
  },
  fetchProductRevenue (config) {
    return Repository.get(`${resource}/campaign_product_revenue.json`, config)
  },
  fetchCampaignStats (config) {
    return Repository.get(`${resource}/campaign_stats.json`, config)
  },
  fetchWebFunnelReport (config) {
    return Repository.get(`${resource}/campaign_funnel_report.json`, config)
  },
  fetchPlatformOverviewData (config) {
    return Repository.get(`${resource}/platform_overview_data.json`, config)
  },
  fetchLanguageOverviewData (config) {
    return Repository.get(`${resource}/language_overview_data.json`, config)
  },
  fetchUserEngagementData (config) {
    return Repository.get(`${resource}/campaign_user_engagement_data.json`, config)
  },
  fetchABReportDetails (config) {
    return Repository.get(`${resource}/ab_detailed.json`, config)
  },
  fetchRecurringDetails (config) {
    return Repository.get(`${resource}/recurring_detailed.json`, config)
  },
  fetchCouponData (config) {
    return Repository.get(`${resource}/campaign_coupon_data.json`, config)
  }
}